import { RegisterOptions } from 'react-hook-form'
import { FormValues } from './index.context'
import { useTranslation } from 'react-i18next'

export const defaultValues: FormValues = {
  clientId: null,
  accountId: null,
  amount: '',
  checkNumber: '',
  autoIncrement: false,
  voidCheck: false,
  issuedDate: '',
  issuedPayee: '',
}

export const amountMaxLengthWithSeparator = 16
export const amountMaxLengthWithoutSeparator = 14

export const useFormRules = (): Record<
  keyof FormValues,
  Omit<RegisterOptions<FormValues>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled' | 'value'>
> => {
  const { t } = useTranslation()
  return {
    clientId: {
      required: {
        value: true,
        message: t('AddNewIssuedCheck:validation.required.client_name'),
      },
    },
    accountId: {
      required: {
        value: true,
        message: t('AddNewIssuedCheck:validation.required.account_name'),
      },
    },
    checkNumber: {
      required: {
        value: true,
        message: t('AddNewIssuedCheck:validation.required.check_number'),
      },
      maxLength: {
        value: 12,
        message: t('AddNewIssuedCheck:validation.max_length.check_number', { maxLength: 12 }),
      },
    },
    amount: {
      required: {
        value: true,
        message: t('AddNewIssuedCheck:validation.required.amount'),
      },
      // maxLength: {
      //   value: amountMaxLengthWithSeparator,
      //   message: t('AddNewIssuedCheck:validation.max_length.amount', { maxLength: amountMaxLengthWithSeparator }),
      // },
      validate: {
        format: (value) => {
          if (value && typeof value === 'string' && value.endsWith('.')) {
            return t('AddNewIssuedCheck:validation.format.amount')
          }
          return true
        },
      },
    },
    issuedDate: {
      required: {
        value: true,
        message: t('AddNewIssuedCheck:validation.required.issued_date'),
      },
    },
    issuedPayee: {
      maxLength: {
        value: 255,
        message: t('AddNewIssuedCheck:validation.max_length.issuedPayee', { maxLength: 255 }),
      },
      required: {
        value: true,
        message: t('AddNewIssuedCheck:validation.required.issued_payee'),
      },
    },
    autoIncrement: {},
    voidCheck: {},
  }
}

export const HEADER_HEIGHT = 56
export const INPUT_WRAPPER_HEIGHT = 73.14
export const PADDING_INFO = 16
export const GAPPING_INFO = 24
export const LABEL_HEIGHT = 22
export const INPUT_FIELD_HEIGHT = 44
export const BODY_HEIGHT = 3 * GAPPING_INFO + PADDING_INFO + 2 * INPUT_WRAPPER_HEIGHT + LABEL_HEIGHT
